import type { ImgHTMLAttributes } from 'react';
import { useState } from 'react';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {}

const ImageComponent = ({ src, alt = 'Image', ...rest }: Props) => {
	const [imageError, setImageError] = useState(false);

	const handleError = () => {
		setImageError(true);
	};

	const placeholderSvg = `data:image/svg+xml;base64,${btoa(`
		<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
			<rect width="100%" height="100%" fill="#f0f0f0" stroke="#ddd" stroke-width="2"/>
			<text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#999" font-family="Arial, sans-serif" font-size="14">
				No Image Available
			</text>
		</svg>
	`)}`;

	return (
		<img
			src={imageError || !src ? placeholderSvg : src}
			alt={alt}
			onError={handleError}
			{...rest}
		/>
	);
};

export default ImageComponent;
